import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/marketing/MarketingClient.tsx");
